/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:cd9820ee-2209-41a5-83e8-35f6fa99b56c",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_A4kQ2nHM0",
    "aws_user_pools_web_client_id": "l2vhctjj580ccc9ba1tm84rqc",
  "oauth": {
        "domain": "your-cognito-domain.auth.us-west-2.amazoncognito.com", // Replace with your Cognito domain
        "scope": ["email", "openid", "profile"],
        "redirectSignIn": "http://localhost:3000/",
        "redirectSignOut": "http://localhost:3000/",
        "responseType": "code" // Use "code" for Authorization Code Grant
    },
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
